import { useState, useEffect, useCallback } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import BreadcrumbNav from 'components/shared/BreadcrumbNav';
import SearchBar from 'components/ui/SearchBar';
import ChatbotIA from 'components/shared/ChatbotIA';
import BandeauSuspension from 'components/shared/BandeauSuspension';
import 'styles/layout.css';

const INACTIVITY_TIMEOUT = 10 * 60 * 60 * 1000; // 10h — journee de travail complete

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSessionExpired = useCallback(() => {
    alert('Session expiree. Reconnectez-vous.');
    logout();
    navigate('/login');
  }, [logout, navigate]);

  useEffect(() => {
    let timer;
    const reset = () => { clearTimeout(timer); timer = setTimeout(handleSessionExpired, INACTIVITY_TIMEOUT); };
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, reset));
    reset();
    return () => { clearTimeout(timer); events.forEach(e => window.removeEventListener(e, reset)); };
  }, [handleSessionExpired]);

  useEffect(() => {
    const handleKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') { e.preventDefault(); setSearchOpen(true); }
      if (e.key === 'Escape') setSearchOpen(false);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  const handleToggleSidebar = () => {
    if (window.innerWidth < 1024) setMobileOpen(!mobileOpen);
    else setCollapsed(!collapsed);
  };

  return (
    <div className={`dashboard ${collapsed ? 'sidebar-collapsed' : ''} ${mobileOpen ? 'sidebar-mobile-open' : ''}`}>
      {mobileOpen && <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />}

      <Sidebar
        collapsed={collapsed}
        userMenuOpen={userMenuOpen}
        onToggleUserMenu={setUserMenuOpen}
      />

      <div className="main-area">
        <Header
          onToggleSidebar={handleToggleSidebar}
          onOpenSearch={() => setSearchOpen(true)}
        />
        {/* ⚠️ AU-DESSUS DU CONTENU, SOUS L'EN-TETE : visible sur TOUS les
            ecrans du tenant, quel que soit celui qu'on ouvre. Un bandeau
            branche ecran par ecran serait oublie quelque part. */}
        <BandeauSuspension />
        <BreadcrumbNav />
        <main className="main-content page-transition">
          <Outlet />
        </main>
        <Footer />
      </div>

      <SearchBar isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
      <ChatbotIA />
    </div>
  );
}
